import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './guards/ProtectedRoute';
import PartnerRoutes from './partner/PartnerRoutes';
import { langPath } from '@/utils/langPath';
import LoginPage from '@/pages/login/LoginPage';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { NavigationGuard } from './guards/NavigationGuiard';
import { useFcmToken } from '@/hooks/fcm/useFcmToken';
import { useEffect } from 'react';
import { OrderToastContainer } from '@/components/toast/OrderToastContainer';
import { useFcmForegroundListener } from '@/hooks/fcm/useFcmForegroundListener';

const AppRouter = () => {
  const RouterInner = () => {
    const { isLoggedIn } = useAuth();
    const { requestFcmToken } = useFcmToken();
    useFcmForegroundListener();

    useEffect(() => {
      if (isLoggedIn) {
        requestFcmToken();
      }
    }, [isLoggedIn, requestFcmToken]);

    return (
      <>
        <Routes>
          <Route
            path="/"
            element={<Navigate to={langPath('/login')} replace />}
          />
          <Route path={langPath('/login')} element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path={langPath('/*')} element={<PartnerRoutes />} />
          </Route>
        </Routes>
        {isLoggedIn && <OrderToastContainer />}
      </>
    );
  };

  return (
    <AuthProvider>
      <NavigationGuard>
        <RouterInner />
      </NavigationGuard>
    </AuthProvider>
  );
};

export default AppRouter;
